import React, { useState } from "react";
import { useMemo } from "react";

export default function MyPCF(props) {
  const listData = props.mypcf ? props.mypcf : [];
  const maxSKS = props.maxSKS ? props.maxSKS : 24;

  /*==DATATABELS CONFIG==*/
  const [totalItems, setTotalItems] = useState(0);

  const ResultData = useMemo(() => {
    let computedData = listData;
    computedData.sort((a, b) =>
      a.detail.coursetitle > b.detail.coursetitle ? 1 : -1
    );
    const objSubjectUniq = computedData.reduce((accumulator, currentValue) => {
      if (currentValue.detail && currentValue.detail.hasOwnProperty('not_billed') && currentValue.detail.not_billed === 0) {
        const { course_id, detail: { course_credit } } = currentValue;
        if (!accumulator.hasOwnProperty(course_id)) {
          accumulator[course_id] = course_credit;
        } else if (accumulator[course_id] !== course_credit) {
          accumulator[course_id] += course_credit;
        }
      }
      return accumulator;
    }, {});
    let tsks = 0;
    console.log(objSubjectUniq);
    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        tsks = tsks + objSubjectUniq[k];
      });
    }

    const courseAdd = computedData.filter(
      (item) => item.action_type === "add"
    );
    setTotalItems(courseAdd.length);
    props.setTotalSKS(tsks);
    return computedData;
  }, [listData]);
  /*==END DATATABELS CONFIG==*/

  return (
    <div className="card card-custom card-stretch gutter-b">
      <div className="card-header align-items-center border-0 mt-4">
        <h3 className="card-title align-items-start flex-column">
          <span className="font-weight-bolder text-dark">My PCF</span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm">
            Please fill in the list of courses you will take
          </span>
        </h3>
      </div>

      <div
        className="card-body py-0 d-flex flex-column justify-content-between"
        style={{ maxHeight: "900px", overflowY: "auto" }}
      >
        <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
          <thead>
            <tr>
              <th><span className="text-dark">COURSE ({totalItems})</span></th>
            </tr>
          </thead>
          <tbody>
            {ResultData.length > 0 ? (
              ResultData.map((v, index) => (
                <tr key={index}>
                  <td className="px-0 py-1">
                    <div className="border p-3 rounded">
                      <div className="d-flex justify-content-start align-items-start">
                        <div className="my-course w-100 ">
                          <span className="font-weight-bolder mb-1">{v.detail.coursetitle}</span>
                          <div>
                            <span className="text-muted font-weight-bold">{v.detail.course_code}</span>
                          </div>
                        </div>
                        <div className='info-course mr-8'>
                          <span className="font-weight-bolder d-block">
                            Credit
                            <span className="ml-2 text-dark font-weight-bold">{v.detail.course_credit}</span>
                          </span>
                        </div>
                        <button
                          className="btn btn-sm btn-icon btn-danger p-5" type="button" title="Remove to your PCF" onClick={() => props.handlerActionCourse({ action_type: "remove", course_id: v.course_id, index: index })} >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                      <div className="section mt-5">
                        <span className="font-weight-bolder d-block">{v?.detail?.section_id} / {v?.detail?.section_name || v?.detail?.coursetitle || "-"}</span>
                        <span className="font-weight-bolder text-muted">Section ID/Name</span>
                      </div>
                      <div className="cost_owner mt-5">
                        {(Object.values(v.detail.lecturer).length > 0) ? (
                          v.detail.lecturer.map((c, index) => (
                            <span key={index} className="font-weight-bolder d-block">
                              {(c.emp) ? c.emp.fullname : "-"}
                            </span>
                          ))
                        ) : "-"}
                        <span className="font-weight-bolder text-muted">Lecturer</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>No record found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="text-center p-5">
        <span className="font-weight-bolder d-block mb-1">
          Total Credit: {props.totalsks} SKS
        </span>
        {props.totalsks > maxSKS && (
          <span className="label label-lg label-light-danger label-inline">
            You have exceeded the maximum SKS
          </span>
        )}
      </div>
    </div>
  );
}
